export enum Action {
  ADD_PRICING_TAG = 'ADD_PRICING_TAG',
  ADD_PRICING_SPEC_FORM = 'ADD_PRICING_SPEC_FORM',
  ADD_PRICING_SPEC_BY_ID = 'ADD_PRICING_SPEC_BY_ID',
  CHANGE_PRICING_NAME = 'CHANGE_PRICING_NAME',
  REMOVE_ALL_PRICING_SPECS_IN_LENDER_CONTEXT = 'REMOVE_ALL_PRICING_SPECS_IN_LENDER_CONTEXT',
}
